import { useMutation } from "@apollo/client";

import { ManagedUserInviteInputV2 } from "types/generated";

import { INVITE_MANAGED_USER_V2 } from "../gql";

const useInviteUserV2 = () => {
  const [inviteManagedUser, { loading }] = useMutation(INVITE_MANAGED_USER_V2, {
    refetchQueries: ["GetManagedUsers", "GetAccountSettings"],
  });

  const onCreate = (input: ManagedUserInviteInputV2) => {
    return inviteManagedUser({
      variables: {
        input,
      },
    });
  };

  return { onCreate, loading };
};

export default useInviteUserV2;
